/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.fire({
            title: 'このアイテムを削除してもよろしいですか?',
            showCancelButton: true,
            confirmButtonText: '削除',
            cancelButtonText: 'キャンセル',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'これを実行してもよろしいですか？',
                showCancelButton: true,
                confirmButtonText: '確認',
                cancelButtonText: 'キャンセル',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'これを実行してもよろしいですか？',
            showCancelButton: true,
            confirmButtonText: '確認',
            cancelButtonText: 'キャンセル',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();


    if (typeof quilljs_textarea === "function") {
        var toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            ['link', 'image'],
            [{'header': 1}, {'header': 2}],               // custom button values
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
            [{'direction': 'rtl'}],                         // text direction

            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
            [{'header': [1, 2, 3, 4, 5, 6, false]}],

            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
            [{'font': []}],
            [{'align': ''}, {'align': 'center'}, {'align': 'justify'}, {'align': 'right'}],

            ['clean']                                         // remove formatting button
        ];

        quilljs_textarea('textarea.quill-editor', {
            modules: {
                toolbar: toolbarOptions
            },
            theme: 'snow'
        });
    }


    if (typeof $().datepicker === 'function') {
        $(".datepicker").datepicker({dateFormat: 'yy-mm-dd'}).keyup(function(e) {
            if(e.keyCode == 8 || e.keyCode == 46) {
                $.datepicker._clearDate(this);
            }
        });
    }
    if (typeof $().datetimepicker === 'function') {
        $.datetimepicker.setLocale('ja');
        $('.datetime_picker').datetimepicker({
          format: 'Y-m-d H:i',
          step: 5
        });
        $('.daterange_picker').datetimepicker({
            format: 'Y-m-d',
            timepicker: false,
        });
        $('#date_from').on('change', function () {
            let date_from = $(this).val();
            let date_to = $('#date_to').val();
            if (date_to < date_from) $('#date_to').val(date_from);
        });
        $('#date_to').on('change', function () {
            let date_from = $('#date_from').val();
            let date_to = $(this).val();
            if (date_to < date_from) $('#date_from').val(date_to);
        })
    }

    var avatar = document.getElementById('avatar_image');
    var input = document.getElementById('avatar_file');
    if (avatar && input) {
        input.addEventListener('change', function (e) {
            var files = e.target.files;
            var done = function (url) {
                avatar.src = url;
            };
            var reader;
            var file;
            if (files && files.length > 0) {
                file = files[0];

                avatar.src = '';
                if (file.size > 10 * 1024 * 1024) {
                    input.value = null;
                    alert('10M以上のファイルはアップロードできません。');
                    return;
                }
                if (URL) {
                    done(URL.createObjectURL(file));
                } else if (FileReader) {
                    reader = new FileReader();
                    reader.onload = function (e) {
                        done(reader.result);
                    };
                    reader.readAsDataURL(file);
                }
            }
        });
    }
});
